import Vue from 'vue'
import App from './App.vue'
import { router } from './router'
import { ethers } from 'ethers'
import * as Highcharts from 'highcharts'
import readXlsxFile from 'read-excel-file'
import store from './store';
import * as VeeValidate from 'vee-validate';
import Vuex from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import vuetify from "./plugins/Vuetify";

import {
  faHome,
  faUser,
  faUserPlus,
  faSignInAlt,
  faSignOutAlt
} from '@fortawesome/free-solid-svg-icons';
import Lottie from "vue-lottie";

Vue.component("lottie", Lottie);

library.add(faHome, faUser, faUserPlus, faSignInAlt, faSignOutAlt);

Vue.use(VeeValidate);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(Vuex);

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App),
}).$mount('#app')

Vue.prototype.Apps = {
	web3: null,
  	account: null,
  	meta: null,
	start: async function() {
    	const { web3 } = this;

    	try {
			const abiData= require('./ABI.json'); 
			this.meta = new web3.eth.Contract(abiData,
			"0x5ab3B0f4dc5aAAf431642BB8cB72168ad8b92ECd",);
			
			let accounts = await web3.eth.getAccounts();
			this.account = accounts[0];
			console.log(this.account);
			
///////////////////////////////////////

		let bal = await web3.eth.getBalance(this.account)/1000000000000000000;
		document.getElementById("balance_eth").innerHTML = bal.toFixed(5) + ' ' + 'ETH';

		const { getAssetPrice } = this.meta.methods;
		await getAssetPrice().call().then(function(result) {
		var balanceinEur = ((result/100000000)).toFixed(0);
		document.getElementById("balance").innerHTML = (bal*balanceinEur).toFixed(2) + ' ' + 'EUR';
		document.getElementById("pricePerETH").innerHTML = '1' + ' ETH' + ' = ' + (balanceinEur) + ' EUR';
  		});
     	} catch(error) {
			console.error("Could not connect to contract or chain. ");
		}	  
		
		var data, tr, td, v1;
		var table = document.getElementById('transactions');
		this.meta.getPastEvents('LogEntityInfo', {
			filter: {addr: this.account}, 
			fromBlock: 0,
			toBlock: 'latest'
		}, function(error, events){ console.log(events); 
				for(var i=0;i<events.length;i++){
            		tr = document.createElement('tr');
					for(var j=0;j<8;j++){
						if((events[i].returnValues[j]).length == '66'){
                			data = ethers.utils.parseBytes32String(events[i].returnValues[j]);
                			td = document.createElement('td');  
                			v1 = document.createTextNode(data);
							td.appendChild(v1);
							tr.appendChild(td);
						}
                		else{
							if((events[i].returnValues[j]).length == '10' ){
								var num = Number(events[i].returnValues[j]);
                        		var date_ob = new Date(num*1000);
                        		var year = date_ob.getFullYear();
                        		var month = ("0" + (date_ob.getMonth() + 1)).slice(-2);
                        		var date = ("0" + date_ob.getDate()).slice(-2);
                        		var fulldate = date + "-" + month + "-" + year;
                        		data = fulldate;
							}
							else
                			data = events[i].returnValues[j];				
                			td = document.createElement('td');  
                			v1 = document.createTextNode(data);
							td.appendChild(v1);
							tr.appendChild(td);
						}
					}
					table.appendChild(tr);
				}
			});
		
			this.meta.getPastEvents('LogofferDetails', {
				filter: {addr: this.account}, // Using an array means OR: e.g. 20 or 23
				fromBlock: 0,
				toBlock: 'latest'
				}, async function(error, events){ 
					for(var i=0;i<events.length;i++){
            			tr = document.createElement('tr');
						for(var j=0;j<8;j++){
							if((events[i].returnValues[j]).length == '66'){
                				data = ethers.utils.parseBytes32String(events[i].returnValues[j]);
                				td = document.createElement('td');  
                				v1 = document.createTextNode(data);
								td.appendChild(v1);
								tr.appendChild(td);
							}
                			else{
								if((events[i].returnValues[j]).length == '10' ){
									var num = Number(events[i].returnValues[j]);
                        			var date_ob = new Date(num*1000);
                        			var year = date_ob.getFullYear();
                        			var month = ("0" + (date_ob.getMonth() + 1)).slice(-2);
                        			var date = ("0" + date_ob.getDate()).slice(-2);
                       				var fulldate = date + "-" + month + "-" + year;
                        			data = fulldate;
									
								}
								else
               					data = events[i].returnValues[j];
								   if(j == 3 && events[i].returnValues[10] >0){
									data = Number(events[i].returnValues[3]/10**(events[i].returnValues[10]));
								} 			
                				td = document.createElement('td');  
                				v1 = document.createTextNode(data);
								td.appendChild(v1);
								tr.appendChild(td);
							}
						}
						table.appendChild(tr);
					}
				}
			);

			this.meta.getPastEvents('LogrequestDetails', {
				filter: {addr: this.account},
				fromBlock: 0,
				toBlock: 'latest'
				}, async function(error, events){ console.log(events);
					for(var i=0;i<events.length;i++){
            			tr = document.createElement('tr');
						for(var j=0;j<8;j++){
							if((events[i].returnValues[j]).length == '66'){
                				data = ethers.utils.parseBytes32String(events[i].returnValues[j]);
                				td = document.createElement('td');  
                				v1 = document.createTextNode(data);
								td.appendChild(v1);
								tr.appendChild(td);
							}
                			else{
								if((events[i].returnValues[j]).length == '10' ){
									
									var num = Number(events[i].returnValues[j]);
                        			var date_ob = new Date(num*1000);
                        			var year = date_ob.getFullYear();
                        			var month = ("0" + (date_ob.getMonth() + 1)).slice(-2);
                        			var date = ("0" + date_ob.getDate()).slice(-2);
                       				var fulldate = date + "-" + month + "-" + year;
                        			data = fulldate;
									
								}
								else
               					data = events[i].returnValues[j];
								   if(j == 3 && events[i].returnValues[10] >0){
									data = Number(events[i].returnValues[3]/10**(events[i].returnValues[10]));
								} 			
                				td = document.createElement('td');  
                				v1 = document.createTextNode(data);
								td.appendChild(v1);
								tr.appendChild(td);
							}
						}
						table.appendChild(tr);
					}
				}
			);
		
			this.meta.getPastEvents('LogofferRequest', {
				filter: {addr: this.account}, // Using an array means OR: e.g. 20 or 23
				fromBlock: 0,
				toBlock: 'latest'
				}, function(error, events){ 
					console.log(events); 
					for(var i=0;i<events.length;i++){
						tr = document.createElement('tr');
						for(var j=0;j<8;j++){
							if((events[i].returnValues[j]).length == '66'){
								data = ethers.utils.parseBytes32String(events[i].returnValues[j]);
								td = document.createElement('td');  
								v1 = document.createTextNode(data);
								td.appendChild(v1);
								tr.appendChild(td);
							}
							else{
								if((events[i].returnValues[j]).length == '10' ){
									var num = Number(events[i].returnValues[j]);
									var date_ob = new Date(num*1000);
									var year = date_ob.getFullYear();
									var month = ("0" + (date_ob.getMonth() + 1)).slice(-2);
									var date = ("0" + date_ob.getDate()).slice(-2);
									var fulldate = date + "-" + month + "-" + year;
									data = fulldate;
								}
								else
								data = events[i].returnValues[j];				
								td = document.createElement('td');  
								v1 = document.createTextNode(data);
								td.appendChild(v1);
								tr.appendChild(td);
							}
						}
						table.appendChild(tr);
					}
				}
			);

			this.meta.getPastEvents('LogValidationDetails', {
				filter: {addr: this.account}, // Using an array means OR: e.g. 20 or 23
				fromBlock: 0,
				toBlock: 'latest'
				}, function(error, events){ 
					console.log(events); 
					for(var i=0;i<events.length;i++){
						tr = document.createElement('tr');
						for(var j=0;j<8;j++){
							if((events[i].returnValues[j]).length == '66'){
								data = ethers.utils.parseBytes32String(events[i].returnValues[j]);
								td = document.createElement('td');  
								v1 = document.createTextNode(data);
								td.appendChild(v1);
								tr.appendChild(td);
							}
							else{
								if((events[i].returnValues[j]).length == '10' ){
									var num = Number(events[i].returnValues[j]);
									var date_ob = new Date(num*1000);
									var year = date_ob.getFullYear();
									var month = ("0" + (date_ob.getMonth() + 1)).slice(-2);
									var date = ("0" + date_ob.getDate()).slice(-2);
									var fulldate = date + "-" + month + "-" + year;
									data = fulldate;
								}
								else
								data = events[i].returnValues[j];
								if(j == 3 && events[i].returnValues[9] >0){
									data = Number(events[i].returnValues[3]/10**(events[i].returnValues[9]));
								} 					
								td = document.createElement('td');  
								v1 = document.createTextNode(data);
								td.appendChild(v1);
								tr.appendChild(td);
							}
						}
						table.appendChild(tr);
					}
				}
			);
},
 
register: async function() {	  
	const _name = document.getElementById('companyName').value;
    const _city = document.getElementById('city').value;
    const _companyType = document.getElementById('companyType').value;
	
	const { web3 } = this;
	const accounts = await web3.eth.getAccounts();
	this.account = accounts[0];
 
    const { register } = this.meta.methods;
	const _companyName =  ethers.utils.formatBytes32String(_name);
	const _location = ethers.utils.formatBytes32String(_city);
	const _compType = ethers.utils.formatBytes32String(_companyType);
   	await register(this.account, _compType, _location, _companyName).send({ from: this.account, gas: '1000000' })
   .on('transactionHash', function(hash){
		// document.getElementById("loader").style.display = "block";
		// document.getElementById("helper").style.display = "inline-block";
		// document.getElementById("trans").style.display = "inline-block";
		// console.log(hash);
    	// document.getElementById("link").href = "https://ropsten.etherscan.io/tx/" + hash; 
	})
   .on('receipt',function(receipt){
		console.log("done",receipt);
		// document.getElementById("loader").style.display = "none";
		// document.getElementById("helper").style.display = "none";
		// document.getElementById("trans").style.display = "none";
		//	window.location.href="https://eflex-interrface.netlify.app/dashboard"
		//window.location.href="http://localhost:8081/dashboard"
	})
	.on('error',function(){
		// 	document.getElementById("loader").style.display = "none";
		// 	document.getElementById("helper").style.display = "none";
		// document.getElementById("trans").style.display = "none";
	});
},

registerOffer: async function() {	  
    let _city = document.querySelector(".locationClass .v-select__selection")
    let _when = document.querySelector(".dayTypeClass .v-select__selection")
	let _asstName  = document.querySelector(".assetTypeClass .v-select__selection")
	const _datef = document.getElementById('dateFrom').value;
	const _datet = document.getElementById('dateTo').value;
	const _timef = document.getElementById('timeFrom').value;
	const _timet = document.getElementById('timeTo').value;
    const _volume = document.getElementById('volume').value;
	const _price = document.getElementById('price').value;

	const { web3 } = this;
	const accounts = await web3.eth.getAccounts();
	this.account = accounts[0];
	const _When =  ethers.utils.formatBytes32String(_when);
	const _location = ethers.utils.formatBytes32String(_city.textContent);
	const _aName = ethers.utils.formatBytes32String((_asstName.textContent).trim());
	var newDate1 = _datef + " " + _timef ;
    var newDate2 = _datet + " " + _timet ; 
	var dateString = newDate1,
    dateTimeParts = dateString.split(' '),
    timeParts = dateTimeParts[1].split(':'),
    dateParts = dateTimeParts[0].split('-'),
    date;
    date = new Date(dateParts[0], parseInt(dateParts[1], 10) - 1, dateParts[2], timeParts[0], timeParts[1]);
    var dateString2 = newDate2,
    dateTimeParts2 = dateString2.split(' '),
    timeParts2 = dateTimeParts2[1].split(':'),
    dateParts2 = dateTimeParts2[0].split('-'),
    date2;
    date2 = new Date(dateParts2[0], parseInt(dateParts2[1], 10) - 1, dateParts2[2], timeParts2[0], timeParts2[1]);
	const _startDateTime = date.getTime();
	const _endDateTime = date2.getTime();
	var d1 = new Date(_datef);
	var d2 = new Date(_datet);
	var days = d1.getTime() - d2.getTime()/(1000 * 3600 * 24);
	// document.getElementById("offerConfirmation").innerHTML = 'false';
	//volume decimals
	var finalVolume = 0;
	var decimalPlace = 0;
	if(Math.floor(_volume) === Number(_volume)){
		decimalPlace = 0;
		finalVolume = _volume;
	}
	else {
		decimalPlace = _volume.toString().split(".")[1].length;
		finalVolume = Math.round(_volume*(10**decimalPlace));
	}
	//signed volume
	var signedVolume = Math.round(_volume*(10**decimalPlace));

    const { registerOffer } = this.meta.methods;
    await registerOffer(this.account, _price, Math.abs(finalVolume), signedVolume, decimalPlace, _startDateTime, _endDateTime, days, _location, _aName).send({ from: this.account, gas: '1000000' })
	.on('transactionHash', function(hash){
		// document.getElementById("offerLoader").style.display = "block";
		// document.getElementById("offerHelper").style.display = "inline-block";
		// document.getElementById("offerTrans").style.display = "inline-block";
		console.log(hash);
		// document.getElementById("offerLink").href = "https://goerli.etherscan.io/tx/" + hash; 
	})
	.on('receipt',function(receipt){
		
		store.commit('block/receipt', receipt.events.LogofferDetails.returnValues.offerID)
 		store.commit('block/change', true)})
	.on('error',function(){
		// document.getElementById("offerLoader").style.display = "none";
		// document.getElementById("offerHelper").style.display = "none";
		// document.getElementById("offerTrans").style.display = "none";
	});
			
},

registerRequest: async function() {	  
	let _city = document.querySelector(".reqlocationClass .v-select__selection")
    let _when = document.querySelector(".reqcompanyType .v-select__selection")
	const _datef = document.getElementById('reqdateFrom').value;
	const _datet = document.getElementById('reqdateTo').value;
	const _timef = document.getElementById('reqtimeFrom').value;
	const _timet = document.getElementById('reqtimeTo').value;
    const _volume = document.getElementById('reqvolume').value;
	const _price = document.getElementById('reqprice').value;
	const { web3 } = this;
	const accounts = await web3.eth.getAccounts();
	this.account = accounts[0];
	const _When =  ethers.utils.formatBytes32String(_when);
	const _location = ethers.utils.formatBytes32String(_city);
	var newDate1 = _datef + " " + _timef ;
    var newDate2 = _datet + " " + _timet ; 
	var dateString = newDate1,
    dateTimeParts = dateString.split(' '),
    timeParts = dateTimeParts[1].split(':'),
    dateParts = dateTimeParts[0].split('-'),
    date;
    date = new Date(dateParts[0], parseInt(dateParts[1], 10) - 1, dateParts[2], timeParts[0], timeParts[1]);
    var dateString2 = newDate2,
    dateTimeParts2 = dateString2.split(' '),
    timeParts2 = dateTimeParts2[1].split(':'),
    dateParts2 = dateTimeParts2[0].split('-'),
    date2;
    date2 = new Date(dateParts2[0], parseInt(dateParts2[1], 10) - 1, dateParts2[2], timeParts2[0], timeParts2[1]);
	const _startDateTime = date.getTime();
	const _endDateTime = date2.getTime();
	var d1 = new Date(_datef);
	var d2 = new Date(_datet);
	var days = d1.getTime() - d2.getTime()/(1000 * 3600 * 24);

	//volume decimals
	var finalVolume = 0;
	var decimalPlace = 0;
	if(Math.floor(_volume) === Number(_volume)){
		decimalPlace = 0;
		finalVolume = _volume;
	}
	else {
		decimalPlace = _volume.toString().split(".")[1].length;
		finalVolume = Math.round(_volume*(10**decimalPlace));
	}
	//signed volume
	var signedVolume = Math.round(_volume*(10**decimalPlace));

    const { registerRequest } = this.meta.methods;
    await registerRequest(this.account, _price, Math.abs(finalVolume), signedVolume, decimalPlace,_startDateTime, _endDateTime, days, _location, _When).send({ from: this.account, gas: '1000000' })
	.on('transactionHash', function(hash){
	}).on('receipt',function(receipt){
		store.commit('block/change', true)
	})
	.on('error',function(){
		store.commit('block/change', true)
			alert("error in transaction")
	});
},

registerBulkOffer: async function(uDateFrom, uDateTo, uTimeFrom, uTimeTo, uVolume, uPrice){
	console.log("Array",uDateFrom, uDateTo, uTimeFrom, uTimeTo, uVolume, uPrice);
	var uDate1, uDate2, udateString;
	var udateTimeParts, utimeParts, udateParts, udate;
	//volume decimals
	var ufinalVolume = 0;
	var udecimalPlace = 0;
	var uDateTimeFrom = [];
	var uDateTimeTo = [];
	var uSignedVolume = [];
	var uDecimals = [];
	var _uPrice = [];
	var uAbsVolume = [];

	for(var i=0; i<uVolume.length; i++){
		uDate1 = uDateFrom[i] + " " + uTimeFrom[i] ;
    	uDate2 = uDateTo[i] + " " + uTimeTo[i] ; 
		udateString = uDate1,
    	udateTimeParts = udateString.split(' '),
    	utimeParts = udateTimeParts[1].split(':'),
    	udateParts = udateTimeParts[0].split('-'),
    	udate;
    	udate = new Date(udateParts[0], parseInt(udateParts[1], 10) - 1, udateParts[2], utimeParts[0], utimeParts[1]);
    	var dateString2 = uDate2,
    	dateTimeParts2 = dateString2.split(' '),
    	timeParts2 = dateTimeParts2[1].split(':'),
    	dateParts2 = dateTimeParts2[0].split('-'),
    	date2;
    	date2 = new Date(dateParts2[0], parseInt(dateParts2[1], 10) - 1, dateParts2[2], timeParts2[0], timeParts2[1]);
		const _ustartDateTime = udate.getTime();
		const _uendDateTime = date2.getTime();
	
		if(Math.floor(uVolume[i]) === Number(uVolume[i])){
			udecimalPlace = 0;
			ufinalVolume = Math.abs(uVolume[i]);
		}
		else {
			udecimalPlace = uVolume[i].toString().split(".")[1].length;
			ufinalVolume = Math.abs(Math.round(uVolume[i]*(10**udecimalPlace)));
		}
		//signed volume
		uSignedVolume.push(Math.round(uVolume[i]*(10**udecimalPlace)));
		uDecimals.push(udecimalPlace);
		uDateTimeFrom.push(_ustartDateTime);
		uDateTimeTo.push(_uendDateTime);
		_uPrice.push(Math.round(uPrice[i]));
		
		uAbsVolume.push(ufinalVolume);
	}
	const { web3 } = this;
	const accounts = await web3.eth.getAccounts();
	this.account = accounts[0];
	const { registerBulkOffer } = this.meta.methods;
    await registerBulkOffer(this.account, uAbsVolume, uSignedVolume, uDecimals, _uPrice, uDateTimeFrom, uDateTimeTo).send({ from: this.account })
	.on('receipt',function(receipt){
		store.commit('block/updateReceipt', receipt.events.LogBulkOffer.returnValues.returnedID);
		console.log("Bulkkkkkk",receipt.events.LogBulkOffer.returnValues.returnedID);
	})
	.on('error',function(){
	});
},

updateFlexOffer: async function(_editOfferID) {
	let _ecity = document.querySelector(".editLocation .v-select__selection");
	let _easstName  = document.querySelector(".eassetTypeClass .v-select__selection")
	const _edatef = document.getElementById('edateFrom').value;
	const _edatet = document.getElementById('edateTo').value;
	const _etimef = document.getElementById('etimeFrom').value;
	const _etimet = document.getElementById('etimeTo').value;
    const _evolume = document.getElementById('evolume').value;
	const _eprice = document.getElementById('eprice').value;

	const _elocation = ethers.utils.formatBytes32String(_ecity.textContent);
	const _eaName = ethers.utils.formatBytes32String((_easstName.textContent));
	var enewDate1 = _edatef + " " + _etimef ;
    var enewDate2 = _edatet + " " + _etimet ; 
	var edateString = enewDate1,
    edateTimeParts = edateString.split(' '),
    etimeParts = edateTimeParts[1].split(':'),
    edateParts = edateTimeParts[0].split('-'),
    edate;
    edate = new Date(edateParts[0], parseInt(edateParts[1], 10) - 1, edateParts[2], etimeParts[0], etimeParts[1]);
    var edateString2 = enewDate2,
    edateTimeParts2 = edateString2.split(' '),
    etimeParts2 = edateTimeParts2[1].split(':'),
    edateParts2 = edateTimeParts2[0].split('-'),
    edate2;
    edate2 = new Date(edateParts2[0], parseInt(edateParts2[1], 10) - 1, edateParts2[2], etimeParts2[0], etimeParts2[1]);
	const _estartDateTime = edate.getTime();
	const _eendDateTime = edate2.getTime();
	var ed1 = new Date(_edatef);
	var ed2 = new Date(_edatet);
	var edays = ed1.getTime() - ed2.getTime()/(1000 * 3600 * 24);

	var efinalVolume = 0;
	var edecimalPlace = 0;
	if(Math.floor(_evolume) === Number(_evolume)){
		edecimalPlace = 0;
		efinalVolume = _evolume;
	}
	else {
		edecimalPlace = _evolume.toString().split(".")[1].length;
		efinalVolume = Math.round(_evolume*(10**edecimalPlace));
	}
	//signed volume
	var esignedVolume = Math.round(_evolume*(10**edecimalPlace));
	var _editID;
	await fetch("https://eflex-api-prod.azurewebsites.net/offer/api/offers/"+_editOfferID)
  	.then((response) => response.json()) 
  	.then((_editObj) => {
		_editID = _editObj.bcId; 
 	});
	
	const { updateOffer } = this.meta.methods;
	await updateOffer(this.account, _editID, _eprice, Math.abs(efinalVolume), esignedVolume, edecimalPlace, 
	_estartDateTime, _eendDateTime, edays, _elocation, _eaName).send({ from: this.account, gas: '1000000' })
	.on('transactionHash', function(hash){
		})
	.on('receipt',function(){
		// store.commit('change', true)
	})
	.on('error',function(){	
	});
},

updateFlexRequest: async function() {
	const { updateFlex } = this.meta.methods;
    await updateFlex(this.account).send({ from: this.account, gas: '1000000' })
	.on('transactionHash', function(hash){
	})
	.on('receipt',function(){
	})
	.on('error',function(){
		// document.getElementById("updateRTrans").style.display = "none";		
	});
},

getOffers: async function() {
    const { getOffers } = this.meta.methods;
    const ids = await getOffers().call();
	
	const { getOfferedRes } = this.meta.methods;
	var table = document.getElementById('offersTable');
	for(var i=0;i<ids.length;i++){
		await getOfferedRes(ids[i]).call().then(function(result){
		// initialize new Date object
    	var num = Number(result[1]);
    	var date_ob = new Date(num);
    	var year = date_ob.getFullYear();
   		var month = ("0" + (date_ob.getMonth() + 1)).slice(-2);
    	var date = ("0" + date_ob.getDate()).slice(-2);
    	var hours = ("0" + date_ob.getHours()).slice(-2);
    	var minutes = ("0" + date_ob.getMinutes()).slice(-2);
    	var fulldate = date + "-" + month + "-" + year;
    	var fulltime = hours + ":" + minutes;
    	var num2 = Number(result[2]);
    	var date_ob2 = new Date(num2);
    	var year2 = date_ob2.getFullYear();
    	var month2 = ("0" + (date_ob2.getMonth() + 1)).slice(-2);
    	var date2 = ("0" + date_ob2.getDate()).slice(-2);
    	var hours2 = ("0" + date_ob2.getHours()).slice(-2);
    	var minutes2 = ("0" + date_ob2.getMinutes()).slice(-2);
    	var fulldate2 = date2 + "-" + month2 + "-" + year2;
    	var fulltime2 = hours2 + ":" + minutes2;
        var tr = document.createElement('tr'); 
        var td0 = document.createElement('td');  
        var td1 = document.createElement('td');
        var td2 = document.createElement('td');
        var td3 = document.createElement('td');
        var td4 = document.createElement('td');
		var td5 = document.createElement('td');
		var td6 = document.createElement('td');
		var td7 = document.createElement('td');
		var chckbox = document.createElement('input');
		chckbox.type = "checkbox";  
        chckbox.name = "selected_offerID"; 
		chckbox.value = result[0];
		chckbox.id = result[4];
		chckbox.data = result[3];
		var from_date = document.createTextNode(fulldate);
		var to_date = document.createTextNode(fulldate2);
		var from_time = document.createTextNode(fulltime);
		var to_time = document.createTextNode(fulltime2);
		var ovol = document.createTextNode(result[3]);         
		var ocost = document.createTextNode(result[4]);
		var ocity = document.createTextNode(ethers.utils.parseBytes32String(result[5])); 
		var owhen = document.createTextNode(ethers.utils.parseBytes32String(result[6]));
        td0.appendChild(from_date);
        td1.appendChild(to_date);
		td2.appendChild(from_time);
		td3.appendChild(to_time);
		td4.appendChild(ovol);
		td5.appendChild(ocost);
		td6.appendChild(ocity);
		td7.appendChild(owhen);
        tr.appendChild(td0);
        tr.appendChild(td1);
        tr.appendChild(td2);
        tr.appendChild(td3);
        tr.appendChild(td4);
		tr.appendChild(td5);
		tr.appendChild(td6);
		tr.appendChild(td7); 
		tr.appendChild(chckbox);
        table.appendChild(tr);
		});
	}
},

/*
selectOffers: async function() {
	var total_vol = 0, total_activationFee = 0, total_price = 0;
    var items = document.getElementsByName('selected_offerID');
    for(var i=0; i < items.length; i++){
		if(items[i].type=='checkbox' && items[i].checked==true){
			total_vol +=  +items[i].id;
			total_price += +(items[i].data * items[i].id);
			console.log("hour1",items[i].data2);
		}	
	}
	total_activationFee = +(total_price);
	const sum = "Order Summary";
	document.getElementById("Order").innerHTML = sum.bold();
	document.getElementById("tot_price").innerHTML =  " " ;
	document.getElementById("tot_volume").innerHTML = "Total Volume :" + " " + total_vol;
	document.getElementById("actiavtion_fee").innerHTML = "Total Fee:" + " " + total_activationFee.toFixed(2);
},*/

offerRequest: async function() {
	console.log("WPWPWPWPWPWPPWPWPP", store.getters["block/getTransactions"]);
	var matchedOffers = store.getters["block/getTransactions"];
	
	var selected_id = []; 
    var selected_cost = [];	
	var selected_vol = [];
	var total_price = 0, total_vol = 0;
	var matchedOffersLength = 0;
	var _mdecimalPlace, _mVolume = 0;
	//Loop through the CheckBoxes.
	for(var i = 0; i < matchedOffers.length; i++){
		matchedOffersLength = matchedOffers[i].offers;
		for(var j=0; j < matchedOffersLength.length; j++){
			selected_id.push(matchedOffersLength[j].bcId);
			if(Math.floor(matchedOffersLength[j].volume) === Number(matchedOffersLength[j].volume)){
				_mdecimalPlace = 0;
				_mVolume = matchedOffersLength[j].volume;
			}
			else {
				_mdecimalPlace = matchedOffersLength[j].volume.toString().split(".")[1].length;
				_mVolume = Math.round(matchedOffersLength[j].volume*(10**_mdecimalPlace));
			}
			selected_vol.push((Math.abs(_mVolume)));
			selected_cost.push(Math.round(matchedOffersLength[j].acceptedPrice*100));
		}
		total_price = Math.round(Math.abs(matchedOffers[i].totalPrice));
		total_vol = Math.round(Math.abs(matchedOffers[i].totalVolume));
		console.log("total", selected_cost, selected_vol);
	}

	const val = '1000000000000'*total_price;	
	const { web3 } = this;
	const accounts = await web3.eth.getAccounts();
	this.account = accounts[0];	
    const { offerRequest } = this.meta.methods;
	//console.log("selections", selected_id, selected_vol, selected_cost,total_price,total_vol);
    await offerRequest(this.account, selected_id, selected_cost, selected_vol, total_price, total_vol).send({ from: this.account, gas: '1000000', value:val })
	.on('transactionHash', function(hash){
	}).on('receipt',function(receipt){
 		store.commit('block/receipt', receipt.events.LogofferRequest.returnValues.offerRequestID)
 		store.commit('block/change', true)
	})
	.on('error',function(){
		store.commit('block/change', false)
		//alert("error in transaction")		
	});		         
},

finalPay: async function(){
	
	var offeredRes;
	var val;

	const { web3 } = this;
	const accounts = await web3.eth.getAccounts();
	this.account = accounts[0];	
	const { getOfferedRes } = this.meta.methods;
	const { finalPay } = this.meta.methods;

	// var check = await fetch("https://eflex-api-prod.azurewebsites.net/api/v1/transaction/list");
	// console.log("APIIIII",check);
	console.log("WVVVVVVVVVVVVVVVV", store.getters["block/getValidations"]);
	let validationID = store.getters["block/getValidations"];
	console.log("IDDDDDDD",validationID.bcId);
	//https://eflex-api-prod.azurewebsites.net/api/v1/transaction/validation?requestCode=BGDSO178431REQ10
	//console.log("VALOBJJJJJ",validateObjectID.bcId);

		offeredRes = await getOfferedRes(validationID.bcId).call();
		var deliveryRateFinal = validationID.deliveryRate;
		if(Math.abs(deliveryRateFinal) > 85)
		val = web3.utils.toBN('1000000000000'* (validationID.deliveryRate * offeredRes[5]));
		else
		val = web3.utils.toBN('1000000000000'* (offeredRes[5]));
	
    	await finalPay(offeredRes[9],this.account, Number(val), Number(validationID.bcId), Number(val/1000000000000)).send({ from: this.account, gas: '1000000'})
		.on('transactionHash', function(hash){
		})
		.on('receipt',function(receipt){
		})
		.on('error',function(){
		});
},

};


 //export default Apps
